<script lang="ts" setup>
import type { TailwindColor } from '#shared/types/elementsUi'

interface SocialMediaSectionProps {
  baseKey?: string
  title?: string
  description?: string
  backgroundColor?: TailwindColor
}

const props = withDefaults(defineProps<SocialMediaSectionProps>(), {
  title: 'titles.follow-us-on-social-media',
  backgroundColor: undefined
})

const { baseKey } = useI18n(props.baseKey)
</script>

<template>
  <VSection
    :title
    :description
    :ui="{ section: backgroundColor && `bg-${backgroundColor}` }"
  >
    <template #after>
      <SocialMediaIcons
        :ui="{
          base: 'mt-4'
        }"
      />
    </template>
  </VSection>
</template>

<style scoped></style>
